import React from 'react';
import { cn } from '@/utils/cn';

export function ProjectProgressTimeInfo({ info }: { info: any }) {
  return (
    <div className="bg-white rounded-md border border-slate-100 p-4  space-y-4">
      <h3 className="text-sm font-normal text-slate-900 border-b border-slate-50 pb-2">Thông tin thời gian</h3>
      <div className="space-y-3">
        <InfoRow label="Ngày khởi công" value={info.startDate} />
        <InfoRow label="Ngày hoàn thành dự kiến" value={info.endDate} />
        <InfoRow label="Thời gian kế hoạch" value={`${info.totalDays} ngày`} />
        <InfoRow label="Thời gian đã thực hiện" value={`${info.elapsedDays} ngày`} valueColor="text-emerald-600" />
        <InfoRow label="Thời gian còn lại" value={`${info.remainingDays} ngày`} valueColor="text-blue-600" />
        <InfoRow label="+/- so với kế hoạch" value={`${info.varianceDays} ngày`} valueColor="text-rose-600" />
      </div>
    </div>
  );
}

function InfoRow({ label, value, valueColor = 'text-slate-700' }: any) {
  return (
    <div className="flex justify-between items-center text-xs">
      <span className="font-normal text-slate-400">{label}</span>
      <span className={cn("font-normal", valueColor)}>{value}</span>
    </div>
  );
}
